// Login
export const POST_LOGIN = "/login"

//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

// Company
export const COMPANY_URL = "/api/company"

// Product
export const PRODUCT_URL = "/api/products"

// Company
export const MASTER_URL = "/api/masters?access_type="
export const MASTER_OPTIONS_URL = "/api/masters/options"
export const PRODUCT_OPTIONS_URL = "/api/products/getProductOptions"

// Employee
export const EMPLOYEE_URL = "/api/employee"

// Clients
export const CLIENT_URL = "/api/clients"

// Order
export const ORDER_URL = "/api/orders"
export const RX_UPLOAD = "/api/orders/rxupload"
export const INVOICE_URL = "/api/invoice"
export const INVOICE_CANCEL_URL = "/api/invoice/cancelinvoice"
export const ORDER_STATUS_URL = "/api/orders/hold"

// Challans
export const ORDERFORM_URL = "/api/Challans/genrateOrderform"
export const CHALLAN_URL = "/api/challans"
export const GETORDERFORMS_URL = "/api/getOrderforms"

// Client Options Dropdown
export const DDClients_URL = "/api/selectors/getClientsOptions"

export const ORDER_OPTIONS_URL = "/api/orders/options"

export const ROLE_PERMISSION = "/api/roles/modules"
export const ROLE_PERMISSION_SAVE = "/api/roles/savePermission"
export const ROLE_PERMISSION_GET = "/api/roles/permissions"

// Settings
export const PROFILE = "/api/profile"
export const INVOICE_CONFIG = "/api/profile/invoice"
export const SUBSCRIPTION = "/api/profile/subcription"
export const PROFILE_SETTINGS = "/api/profile/settings"
export const APPROVALS_REQUEST = "/api/approvals/request"
export const APPROVALS_LIST = "/api/approvals/list"
export const APPROVALS_RESPOND = "/api/approvals/respond"
export const EMPLOYEE_SELF_PROFILE = "/api/employee/selfprofile"
export const AUDIT_LOGS_URL = "/api/audit/logs"
export const AUDIT_STATS_URL = "/api/audit/stats"
export const AUDIT_FILTERS_URL = "/api/audit/filters"
export const AUDIT_EXPORT_URL = "/api/audit/export"
export const TRACKING_INTEGRATION_URL = "/api/scanningortracking/tracking_integration"
export const TRACKING_TOGGLE_URL = "/api/scanningortracking/update_tracking"
export const TRACKING_SYNC_AGENTS_URL = "/api/scanningortracking/sync_agents"
export const TRACKING_SYNC_CLIENTS_URL = "/api/scanningortracking/sync_clients"
export const SCANNING_ACCESS_URL = "/api/scanningortracking/access"
export const SCANNING_CONFIG_URL = "/api/scanningortracking/tracking_integration"
export const SCANNING_SYNC_CLIENTS_URL = "/api/scanningortracking/sync_clients"
export const SCANNING_SYNC_EMPLOYEES_URL = "/api/scanningortracking/sync_agents"
export const SCANNING_BOOKINGS_URL = "/api/scanningortracking/bookings"

// Notification
export const WHATSAPP_ADDRESS_SHARE = "/api/notifications/whatsappshareaddress"
export const WHATSAPP = "/api/notifications/whatsapp"
export const WHATSAPP_TEST_URL = "/api/notifications/whatsapptest"
export const SMS_CONFIG = "/api/notifications/sms"
export const SMS_CONFIG_TEST = "/api/notifications/smstest"
export const TEMPLATE_URL = "/api/notifications/templates"
export const NSC_URL = "/api/notifications/notificationSettings"
export const SEND_URL = "/api/notifications/send"
export const MAIL_URL = "/api/smtp"

export const CONVERTINVOICE_URL = "/api/invoice/convertoinvoice"

// Payments
export const DUES_URL = "/api/finance/dues"
export const PAYMENT_URL = "/api/payments"

// Process
export const PROCESS_URL = "/api/process"

// Seatch Clients
export const SEARCHCLIENTS = "/api/search/q"
export const FILTERS = "/api/search/getFilterOptions"

export const BULK_INVOICES = "/api/invoice/bulk"

export const ORDERBYNUM = "/api/orders/getByOrderNumber"

// HRMS
export const LEAVE_URL = "/api/hrms/leaves"
export const LEAVE_TYPE_URL = "/api/hrms/leaves/leave_types"
export const SHIFT_SCHEDULE_URL = "/api/hrms/shift_schedule"
export const SHIFT_DETAILS_URL = "/api/hrms/shift_schedule/details"
export const ROSTER_SHIFTS_URL = "/api/hrms/shifts"
export const ROSTER_RULES_URL = "/api/hrms/shifts/rules"
export const ROSTER_URL = "/api/hrms/shifts/roster"
export const ROSTER_GRID_URL = "/api/hrms/shifts/roster_grid"
export const ASSET_URL = "/api/hrms/assets"
export const ASSET_TYPE_URL = "/api/hrms/assets/asset_type"
export const ASSET_DETAILS_URL = "/api/hrms/assets/details"
export const ASSET_ASSIGN_URL = "/api/hrms/assets/assign"
export const ASSET_RETURN_URL = "/api/hrms/assets/return"
export const ASSET_HISTORY_URL = "/api/hrms/assets/history"

// Payroll
export const PAYROLL_URL = "/api/hrms/payroll"
export const PAYROLL_COMPONENTS_URL = "/api/hrms/payroll/components"
export const PAYROLL_GROUPS_URL = "/api/hrms/payroll/groups"
export const PAYROLL_BONUS_URL = "/api/hrms/payroll/bonus"
export const PAYROLL_TDS_URL = "/api/hrms/payroll/tds"
export const PAYROLL_SSF_URL = "/api/hrms/payroll/ssf"
export const PAYROLL_OVERTIME_URL = "/api/hrms/payroll/overtime"
export const PAYROLL_UNDERTIME_URL = "/api/hrms/payroll/undertime"
export const PAYROLL_PAYMENT_METHODS_URL = "/api/hrms/payroll/payment_methods"
export const PAYROLL_SETTINGS_URL = "/api/hrms/payroll/settings"

// Attendance
export const ATTENDANCE_URL = "/api/hrms/attendance"
export const ATTENDANCE_LOGS_URL = "/api/hrms/attendance/logs"
export const ATTENDANCE_PUNCH_URL = "/api/hrms/attendance/punch"

// System & Cache
export const FLUSH_CACHE_URL = "/api/system/flush_cache"

